import MedicationDSS from "../../../../../templates/views/Encounter/MedicationDSS";

export default {
  path: 'medication-dss',
  name: 'PatientEncounterMedicationDSS',
  component: MedicationDSS,
  meta: {
    // title: 'Encounter - Medication DSS',
    title: t => t('encounter.medicationDSS'),
    loggedInOnly: true,
  }
};
